export const COVER_BACKGROUNDS = [
  '/cover_backgrounds/cover_background_01.svg',
  '/cover_backgrounds/cover_background_02.svg',
  '/cover_backgrounds/cover_background_03.svg',
  '/cover_backgrounds/cover_background_04.svg',
  '/cover_backgrounds/cover_background_05.svg',
  '/cover_backgrounds/cover_background_06.svg',
  '/cover_backgrounds/cover_background_07.svg',
  '/cover_backgrounds/cover_background_08.svg',
  '/cover_backgrounds/cover_background_09.svg',
  '/cover_backgrounds/cover_background_10.svg',
  '/cover_backgrounds/cover_background_11.svg',
  '/cover_backgrounds/cover_background_12.svg',
  '/cover_backgrounds/cover_background_13.svg',
  '/cover_backgrounds/cover_background_14.svg',
  '/cover_backgrounds/cover_background_15.svg',
  '/cover_backgrounds/cover_background_16.svg',
  '/cover_backgrounds/cover_background_17.svg',
  '/cover_backgrounds/cover_background_18.svg',
  '/cover_backgrounds/cover_background_19.svg',
  '/cover_backgrounds/cover_background_20.svg',
  '/cover_backgrounds/cover_background_21.svg',
  '/cover_backgrounds/cover_background_22.svg',
  '/cover_backgrounds/cover_background_23.svg',
  '/cover_backgrounds/cover_background_24.svg',
  '/cover_backgrounds/cover_background_25.svg',
  '/cover_backgrounds/cover_background_26.svg',
  '/cover_backgrounds/cover_background_27.svg',
  '/cover_backgrounds/cover_background_28.svg',
  '/cover_backgrounds/cover_background_29.svg',
  '/cover_backgrounds/cover_background_30.svg',
  '/cover_backgrounds/cover_background_31.svg',
  '/cover_backgrounds/cover_background_32.svg',
  '/cover_backgrounds/cover_background_33.svg',
  '/cover_backgrounds/cover_background_34.svg',
  '/cover_backgrounds/cover_background_35.svg',
  '/cover_backgrounds/cover_background_36.svg',
  '/cover_backgrounds/cover_background_37.svg',
  '/cover_backgrounds/cover_background_38.svg',
  '/cover_backgrounds/cover_background_39.svg',
  '/cover_backgrounds/cover_background_40.svg',
  '/cover_backgrounds/cover_background_41.svg',
  '/cover_backgrounds/cover_background_42.svg',
  '/cover_backgrounds/cover_background_43.svg',
  '/cover_backgrounds/cover_background_44.svg',
  '/cover_backgrounds/cover_background_45.svg',
  '/cover_backgrounds/cover_background_46.svg',
  '/cover_backgrounds/cover_background_47.svg',
  '/cover_backgrounds/cover_background_48.svg',
  '/cover_backgrounds/cover_background_49.svg',
  '/cover_backgrounds/cover_background_50.svg',
]

function hashString(value: string): number {
  let hash = 0
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i)
    hash |= 0
  }
  return Math.abs(hash)
}

export function getCoverBackgroundFromSeed(seed?: string | null): string | undefined {
  if (!seed || !COVER_BACKGROUNDS.length) return undefined
  const index = hashString(seed) % COVER_BACKGROUNDS.length
  return COVER_BACKGROUNDS[index]
}

export function resolveCoverBackgroundUrl(
  existingUrl?: string | null,
  seed?: string | null
): string | undefined {
  if (existingUrl && existingUrl.trim()) {
    return existingUrl
  }
  const computed = getCoverBackgroundFromSeed(seed)
  return computed || undefined
}
